import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../AuthContext'; // Custom hook to get current user info
import Spinner from '../components/spinner'; // Optional: Import a spinner for loading state

interface Friend {
  id: string;
  username: string;
  depositAmount: number | null;
  status: string;
}

const ReferredFriends2: React.FC = () => {
  const [friends, setFriends] = useState<Friend[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const { currentUser } = useAuth(); // Assuming you have a hook to access current user details

  useEffect(() => {
    const fetchReferredFriendsPromo = async () => {
      if (!currentUser) return;

      try {
        console.log('Fetching user data for:', currentUser.uid);

        const userDocRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          console.log('User data:', userData);

          const referredFriendsPromo = userData?.referredFriends || [];
          console.log('Referred friends promo list:', referredFriendsPromo);

          if (referredFriendsPromo.length === 0) {
            console.warn('No friends found in referredFriendsPromo.');
          }

          // Fetch referred friends' details
          const friendDetailsPromises = referredFriendsPromo.map(async (friendId: string) => {
            console.log('Fetching referred friend with ID:', friendId);
            const friendDocRef = doc(db, 'users', friendId);
            const friendDoc = await getDoc(friendDocRef);

            if (friendDoc.exists()) {
              const friendData = friendDoc.data();
              console.log('Friend data:', friendData);

              const depositAmount = friendData?.deposit?.amount || null;
              const status = friendData?.status || 'unverified'; // Fallback to 'unverified'
              const username = friendData?.username || 'Unknown'; // Fallback to 'Unknown'

              return {
                id: friendId,
                username,
                depositAmount,
                status,
              };
            } else {
              console.warn(`Friend document with ID ${friendId} does not exist.`);
            }
            return null;
          });

          const friendDetails = await Promise.all(friendDetailsPromises);
          setFriends(friendDetails.filter((friend) => friend !== null) as Friend[]);
        } else {
          console.error("User document doesn't exist.");
          setError("User document doesn't exist.");
        }
      } catch (err) {
        console.error('Error fetching referred friends:', err);
        setError('Failed to load referred friends.');
      } finally {
        setLoading(false);
      }
    };

    fetchReferredFriendsPromo();
  }, [currentUser]);

  if (loading) return <Spinner />; // Render spinner while loading

  return (
    <div className="p-6 bg-gray-800 rounded-lg shadow-lg max-w-4xl mx-auto text-white">
      <h2 className="text-2xl font-semibold text-gray-100 mb-6">Friends You've Referred</h2>

      {error ? (
        <p className="text-red-400 text-center">{error}</p>
      ) : friends.length === 0 ? (
        <p className="text-gray-400 text-center">You haven’t referred any friends yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-gray-700 table-auto text-gray-200">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b text-left">Username</th>
                <th className="py-2 px-4 border-b text-left">Deposit Amount</th>
                <th className="py-2 px-4 border-b text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {friends.map((friend) => (
                <tr key={friend.id} className="hover:bg-gray-600 transition duration-200">
                  <td className="py-2 px-4 border-b">{friend.username}</td>
                  <td className="py-2 px-4 border-b">
                    {friend.depositAmount !== null ? friend.depositAmount : 'No deposit'}
                  </td>
                  <td className="py-2 px-4 border-b">{friend.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ReferredFriends2;
